import { render, staticRenderFns } from "./CreateConfigurationObjectDlg.vue?vue&type=template&id=ebe56e7c"
import script from "./CreateConfigurationObjectDlg.vue?vue&type=script&lang=js"
export * from "./CreateConfigurationObjectDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports